import { ILanguageWord } from "./words";

export const SPANISH_WORDS: ILanguageWord = {
  verbs: [
    "ser",
    "haber",
    "estar",
    "tener",
    "hacer",
    "poder",
    "decir",
    "ir",
    "ver",
    "dar",
    "saber",
    "querer",
    "llegar",
    "pasar",
    "deber",
    "poner",
    "parecer",
    "quedar",
    "creer",
    "hablar",
    "llevar",
    "dejar",
    "seguir",
    "encontrar",
    "llamar",
    "venir",
    "pensar",
    "salir",
    "volver",
    "tomar",
    "conocer",
    "vivir",
    "sentir",
    "tratar",
    "mirar",
    "contar",
    "empezar",
    "esperar",
    "buscar",
    "existir",
    "entrar",
    "trabajar",
    "escribir",
    "perder",
    "producir",
    "ocurrir",
    "entender",
    "pedir",
    "recibir",
    "recordar",
    "terminar",
    "permitir",
    "aparecer",
    "conseguir",
    "comenzar",
    "servir",
    "sacar",
    "necesitar",
    "mantener",
    "resultar",
    "leer",
    "caer",
    "cambiar",
    "presentar",
    "crear",
    "abrir",
    "considerar",
    "oir",
    "acabar",
    "convertir",
    "ganar",
    "formar",
    "traer",
    "partir",
    "morir",
    "aceptar",
    "realizar",
    "suponer",
    "comprender",
    "lograr",
    "explicar",
    "preguntar",
    "tocar",
    "reconocer",
    "estudiar",
    "alcanzar",
    "nacer",
    "dirigir",
    "correr",
    "utilizar",
    "pagar",
    "ayudar",
    "gustar",
    "jugar",
    "escuchar",
    "cumplir",
    "ofrecer",
    "descubrir",
    "levantar",
    "intentar",
  ],
  conjuctions: [
    "y",
    "e",
    "ni",
    "o",
    "u",
    "pero",
    "aunque",
    "pero",
    "mas",
    "sino",
    "no obstante",
    "excepto",
    "sin embargo",
    "para que",
    "porque",
    "ya que",
    "puesto que",
    "pues",
    "como",
    "si",
    "luego",
  ],
  interjections: [
    "¡ah!",
    "¡oh!",
    "¡ay!",
    "¡guay!",
    "¡eh!",
    "¡hey!",
    "¡uy!",
    "¡puaj!",
    "¡hola!",
    "¡ojalá!",
    "¡eh!",
    "¡uf!",
    "¡bah!",
  ],
  prepositions: [
    "a",
    "antes",
    "de",
    "dentro",
    "desde",
    "despues",
    "durante",
    "en",
    "hasta",
    "por",
    "sobre",
    "tras",
    "con",
    "para",
    "sin",
  ],
  adverbs: [
    "aqui",
    "ya",
    "mal",
    "no",
    "aun",
    "siempre",
    "ultimamente",
    "aca",
    "mejor",
    "mañana",
    "delante",
    "así",
    "temprano",
    "sí",
    "fácilmente",
    "dónde",
    "seguro",
    "qué",
    "tal vez",
    "bastante",
    "mucho",
    "poco",
    "algo",
    "efectivamente",
    "seguramente",
    "por supuesto",
    "ninguno",
    "tampoco",
    "probablemente",
    "todavía",
    "tarde",
    "arriba",
    "lejos",
  ],
  adjectives: [
    "salado",
    "dulce",
    "amargo",
    "ácido",
    "rojo",
    "verde",
    "rubio",
    "fuerte",
    "débil",
    "flexible",
    "tostado",
    "ronco",
    "nítido",
    "áspero",
    "suave",
    "rugoso",
    "esponjoso",
    "flojo",
    "redondo",
    "cuadrado",
    "universitario",
    "institucional",
    "artístico",
    "religioso",
    "cultural",
    "estructural",
    "policial",
    "mensual",
    "diario",
    "solar",
    "militar",
    "navideño",
    "laboral",
    "mercantil",
    "vanguardista",
    "dental",
    "quirúrgico",
    "un",
    "dos",
    "primer",
    "grande",
    "pequeño",
    "diminuto",
    "seco",
    "caro",
    "inteligente",
    "divertido",
    "fiel",
    "agradable",
    "sucio",
    "limpio",
    "amable",
    "nuevo",
    "valiente",
    "hermoso",
    "largo",
    "cruel",
    "perfecto",
    "culto",
    "ancho",
    "musical",
    "democrático",
    "individual",
    "nacional",
    "regional",
    "mundial",
    "económico",
    "político",
    "histórico",
    "civil",
    "familiar",
    "industrial",
    "naval",
    "agrícola",
    "enérgetica",
    "petrolero",
    "segundo",
  ],
  nouns: [
    "amor",
    "explosión",
    "crema",
    "lápiz",
    "embarcación",
    "archipiélago",
    "universidad",
    "llaves",
    "papá",
    "cuna",
    "escuela",
    "lapicera",
    "mapa",
    "lima",
    "edificio",
    "hoja",
    "granizo",
    "mano",
    "música",
    "habitación",
    "guerra",
    "templo",
    "plato",
    "botella",
    "riqueza",
    "planeta",
    "metal",
    "mono",
    "petróleo",
    "debate",
    "ruido",
    "herramienta",
    "anteojos",
    "living",
    "zapato",
    "ojo",
    "alma",
    "buzo",
    "puerta",
    "ensalada",
    "candidato",
    "diario",
    "hierro",
    "relifión",
    "tecla",
    "departamento",
    "hipopótamo",
    "gas",
    "discurso",
    "estusiasmo",
    "fideos",
    "reloj",
    "oscuridad",
    "montañas",
    "moño",
    "partido",
    "fiesta",
    "café",
    "guitarra",
    "martillo",
    "temor",
    "letra",
    "rueda",
    "librería",
    "manada",
    "sillón",
    "teclado",
    "pantalla",
    "tenedor",
    "fauna",
    "cohete",
    "césped",
    "familia",
    "pestaña",
    "salud",
    "hombre",
    "velero",
    "palo",
    "lentes",
    "nube",
    "castillo",
    "verano",
    "televisor",
    "poder",
    "remera",
    "percha",
    "tiempo",
    "pared",
    "cartas",
    "impresora",
    "luces",
    "bomba",
    "corbata",
    "planta",
    "oficina",
    "tío",
    "pradera",
    "deporte",
    "fotografía",
    "refugio",
    "carne",
    "humedad",
    "celular",
    "vocabulario",
    "coro",
    "autos",
    "famoso",
    "piso",
    "diputado",
    "candado",
    "computadora",
    "cuadro",
    "teatro",
    "sueño",
  ],
};
